import React, { useContext } from "react";
import { Tooltip, useDisclosure } from "@chakra-ui/react";
import { ButtonHeaderModule } from "styled/Buttons.styled";
import { IconGeneric } from "styled/Icons.styled";
import { MdContentCopy } from "react-icons/md";
import { TiCancel } from "react-icons/ti";
import { FaHistory } from "react-icons/fa";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { useGlobalLoading } from "utils/globalLoading";
import IntegracionBoxCrudContex from "context/IntegracionBoxCrudContex";
import ModalReturnHistory from "components/modal/ModalReturnHistory";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

export const ButtonsAuthorization = ({
  handleAnular,
  handleCopy,
  handleStatusBox
}) => {
  const { isLoading: isLoadingButton } = useGlobalLoading()
  const { form } = useContext(IntegracionBoxCrudContex);
  const location = useLocation();
  const { id = null } = queryString.parse(location.search);
  const { isOpen: isOpenReturnHistory, onOpen: onOpenReturnHistory, onClose: onCloseReturnHistory } = useDisclosure()
  return (
    <>
      <ModalReturnHistory
        isOpen={isOpenReturnHistory}
        onClose={onCloseReturnHistory}
        onOpen={onOpenReturnHistory}
        title={'Historial de Devoluciones'}
        size={'3xl'}
        entryFormId={id}
        isOutputForm={false}
        isIntegrationCertificate={true}
      />
      {form?.reason_for_return && (
        <Tooltip placement='top' hasArrow label='Historial de Devoluciones'>
          <span>
            <ButtonHeaderModule
              onClick={onOpenReturnHistory}
              bgColor='#FF9800'
              className='mx-1'
              isLoading={isLoadingButton}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={FaHistory}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}
      <Tooltip placement="top" hasArrow label="Anular">
        <span>
          <ButtonHeaderModule
            onClick={handleAnular}
            className="mx-1"
            bgColor="#d33"
            isLoading={isLoadingButton}
          >
            <IconGeneric width="16px" className="text-white" as={TiCancel} />
          </ButtonHeaderModule>
        </span>
      </Tooltip>

      <Tooltip placement="top" hasArrow label="Copiar">
        <span>
          <ButtonHeaderModule
            onClick={handleCopy}
            className="mx-1"
            bgColor="#03C39A"
            isLoading={isLoadingButton}
          >
            <IconGeneric width="16px" className="text-white" as={MdContentCopy} />
          </ButtonHeaderModule>
        </span>
      </Tooltip>

      <Tooltip placement="top" hasArrow label="Corregir">
        <span>
          <ButtonHeaderModule
            onClick={() => handleStatusBox("CORREGIDO")}
            className="mx-1"
            bgColor="#F9A621"
            isLoading={isLoadingButton}
          >
            <IconGeneric
              width="16px"
              className="text-white"
              as={HiOutlineDocumentSearch}
            />
          </ButtonHeaderModule>
        </span>
      </Tooltip>
    </>
  );
};
